module.exports = __webpack_public_path__ + "static/media/GBR Care Infographic home page Desktop - GBR care - 15-04-2025 N.55a8b34e.gif";